module.exports = __webpack_public_path__ + "img/Modernisme_Tida_og_samfunnsforholdene2.90bd8bd9.jpg";